module.exports = __webpack_public_path__ + "img/checked.5df3e30f.svg";